import React from 'react'
import { Box, Paper } from '@mui/material'
import { TrackedLink } from '../TrackedLink'
import { CaretIcon } from '../icons/CaretIcon'

export type NavItemProps = {
  label: string
  to?: string
  dropdownContent?: React.ReactNode
  color?: any
}

const NavItem = (props: NavItemProps) => {
  const { label, dropdownContent, color, to } = props

  if (to) {
    return (
      <TrackedLink
        key={label}
        variant="cta"
        sx={{
          pt: '24px',
          pb: '24px',
          color: 'inherit',
          // color: color || 'primary.main',
          '&:hover': {
            backgroundColor: 'unset',
            color: color || 'primary.main',
          },
        }}
        to={to}
      >
        <Box
          display="flex"
          alignItems="center"
          gap="8px"
          sx={{ pointerEvents: 'none' }}
        >
          {label}
        </Box>
      </TrackedLink>
    )
  }

  return (
    <Box
      sx={{
        position: 'relative',
        '&:hover .dropdown-content': { display: 'block' },
      }}
    >
      <TrackedLink
        key={label}
        variant="cta"
        sx={{
          pt: '24px',
          pb: '24px',
          color: color ? `${color}!important` : 'primary.main',
          '&:hover': { backgroundColor: 'unset' },
        }}
        component="button"
      >
        <Box
          display="flex"
          alignItems="center"
          gap="8px"
          sx={{ pointerEvents: 'none' }}
        >
          {label}{' '}
          {dropdownContent ? <CaretIcon color={color || 'primary'} /> : null}
        </Box>
      </TrackedLink>
      {dropdownContent && (
        <Paper
          className="dropdown-content"
          sx={{
            display: 'none',
            position: 'absolute',
            top: '100%',
            left: 0,
            backgroundColor: 'white',
            borderRadius: '16px!important',
            boxShadow: '0px 8px 24px 0px rgba(69, 73, 77, 0.08)',
            zIndex: 1,
          }}
        >
          {dropdownContent}
        </Paper>
      )}
    </Box>
  )
}

export default NavItem

NavItem.defaultProps = {
  to: '',
}
